import { render, staticRenderFns } from "./QuotesListView.vue?vue&type=template&id=4824fa54"
import script from "./QuotesListView.vue?vue&type=script&lang=ts"
export * from "./QuotesListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports